<template>
    <div class="widget m-0 mb-2 py-2 px-1">
        <div class="row">
            <div class="col-2">
                <div
                    class="rounded-circle mr-2 icon d-flex justify-content-center align-items-center"
                >
                    <i class="text-white fa fa-file-excel-o fa-2x"></i>
                </div>
            </div>
            <div class="col-10">
                <small class="m-0">Export My Goals to EXCEL DOCUMENT</small>
                <div class="d-flex justify-content-start align-items-center">
                    <small style="white-space: nowrap">Select range:&nbsp</small>
                    <span>
                        <v-date-picker
                            :disabled="loading"
                            popover-align="right"
                            mode="range"
                            v-model="interval"
                        ></v-date-picker>
                    </span>
                </div>
                <div class="mt-2">
                    <button
                        :disabled="loading"
                        @click="saveData()"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase"
                    >
                        Save data <i v-if="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    </button>
                    <small v-if="error" class="text-primary font-italic">{{ error }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsExportExcel",
    props: ["patient"],
    data() {
        return {
            interval: {
                start: new Date(),
                end: new Date(),
            },
            error: null,
            loading: false,
        };
    },
    created() {
        this.interval.start.setDate(this.interval.start.getDate() - 7);
    },
    methods: {
        saveData() {
            this.loading = true;
            let start_date = this.moment(this.interval.start).format("YYYY-MM-DD");
            let end_date = this.moment(this.interval.end).format("YYYY-MM-DD");
            this.error = null;
            axios
                .get(
                    `/patients/${
                        this.patient.id
                    }/goals/export-goals?date_range_min=${start_date}&date_range_max=${end_date}`
                )
                .then(response => {
                    this.$swal(
                        "Processing!",
                        "Your report is being generated. You will receive an email in a few minutes.",
                        "success"
                    );
                    this.loading = false;
                })
                .catch(e => {
                    console.error(e);
                    this.$swal("Error", "No data to download.", "error");
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
    border: solid 1px #8f8f8f;
}
.icon {
    background-color: #80b466;
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
}
</style>
<style lang="scss">
.popover-container {
    > input {
        font-size: 0.7rem;
        width: 100%;
    }
}
</style>
